import { render, staticRenderFns } from "./right_yellow.vue?vue&type=template&id=438007ac&scoped=true"
import script from "./right_yellow.vue?vue&type=script&lang=js"
export * from "./right_yellow.vue?vue&type=script&lang=js"
import style0 from "./right_yellow.vue?vue&type=style&index=0&id=438007ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438007ac",
  null
  
)

export default component.exports